'use es6';

import Log from 'forms-utils-lib/logger/Logger';
import { isEmpty, isEqual } from 'underscore';
import { getLegalConsentOptions, getCurrentSelectedLegalConsentOption } from 'FormsUI/selectors/LegalConsent';
import getTranslatedLegalConsent from 'forms-utils-lib/legalConsent/getTranslatedLegalConsent';
import buildLegalConsentDefaultsForTranslate from 'forms-utils-lib/legalConsent/buildLegalConsentDefaultsForTranslate';
import LegalConsentOptions from 'forms-utils-lib/legalConsent/constants/legalConsentOptions';
import LegalConsent from 'FormsCommonComponents/lib/LegalConsent';
import { getBusinessUnitIdForLegalConsent } from 'FormsCommonComponents/utils/BusinessUnitsUtils';
import { getFormsLangToLegalConsentLang } from 'FormsUI/utils/Lang';
import { updateLegalConsent } from 'FormsUI/actions/LegalConsent';
import getSubscriptionsForLegalConsent from 'FormsUI/selectors/legalConsent/getSubscriptionsForLegalConsent';
const translateLegalConsent = (oldLocale, newLocale) => (dispatch, getState) => {
  const state = getState();
  const selectedLegalConsentOption = getCurrentSelectedLegalConsentOption(state);
  const currentLegalConsent = getLegalConsentOptions(state);
  const businessUnitId = getBusinessUnitIdForLegalConsent(state);
  const subscriptionDefinitions = getSubscriptionsForLegalConsent(state);
  if (selectedLegalConsentOption === LegalConsentOptions.NONE || isEmpty(currentLegalConsent)) {
    return;
  }
  const communicationConsentCheckboxes = currentLegalConsent.communicationConsentCheckboxes;
  buildLegalConsentDefaultsForTranslate({
    businessUnitId,
    oldLang: getFormsLangToLegalConsentLang(oldLocale),
    newLang: getFormsLangToLegalConsentLang(newLocale),
    selectedLegalConsentOption,
    subscriptionDefinitions,
    communicationConsentCheckboxes
  }).then(({
    oldLegalConsent,
    newLegalConsent
  }) => {
    const updatedLegalConsent = getTranslatedLegalConsent(currentLegalConsent.toJS(), oldLegalConsent, newLegalConsent);
    const updatedLegalConsentRecord = new LegalConsent(updatedLegalConsent);
    const hasLegalConsentChanged = !isEqual(currentLegalConsent, updatedLegalConsent);
    if (hasLegalConsentChanged) {
      dispatch(updateLegalConsent(updatedLegalConsentRecord));
    }
  }).catch(e => {
    Log.error(`Unable to build legal consent default for translation`, e);
  });
};
export default translateLegalConsent;